import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationBanner } from '../../../models/notification-class.enum';
import { CVA_CONSTANTS } from '../../../util/constants';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { LoginService } from '../../../services/login/login.service';
import { Subscription } from 'rxjs';
import { FuseAlertComponent } from '@fuse/components/alert';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute } from '@angular/router';
import { CVA_AUTH_MODULES } from 'app/models/auth.modules.enum';
import { FuseAlertType } from '@fuse/components/alert/alert.types';
import { PaymentService } from 'app/services/payment/payment.service';
@Component({
  selector: 'cva-standalone-subscription-validator',
  templateUrl: './subscription-validator.component.html',
  styleUrl: './subscription-validator.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FuseAlertComponent],
  animations: fuseAnimations
})
export class SubscriptionValidatorComponent implements OnInit, OnDestroy {
  public loginStatusSubscription!: Subscription;
  notification!: NotificationBanner | undefined;

  constructor(
    private readonly _changeDetectorRef: ChangeDetectorRef,
    private readonly authorize: CustomLoginService,
    public loginService: LoginService,
    private readonly paymentService: PaymentService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loginStatusSubscription = this.loginService.loggedIn$.subscribe((val: boolean) => {
      const actionMap = {
        "true": () => this.checkUserValidity(),
        "false": () => this.makeNotionVoid(),
      };
      actionMap[String(val)]?.();
    });
  }

  private makeNotionVoid() {
    this.notification = null;
  }

  async checkIfCurrentUserIsAdmin() {
    return await this.authorize.IsAuthorized(
      CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT,
      CVA_CONSTANTS.PERMISSION.READ
    );
  }

  checkUserValidity(): void {
    this.paymentService.validateSubscription().subscribe({
      next: (response) => {
        if (!response) {
          this.makeNotionVoid();
          this._changeDetectorRef.markForCheck();
          return;
        }
        this.checkIfCurrentUserIsAdmin().then((isAdmin) => {
          if (isAdmin || (!isAdmin && (response.isCancelled || response.isPaused))) {
            this.notification = {
              type: response.alertType as FuseAlertType,
              message: response.message
            }
          } else {
            this.makeNotionVoid();
          }
          this._changeDetectorRef.markForCheck();
        }).catch((error) => {
          this.makeNotionVoid();
          throw error;
        })
      },
      error: (err) => {
        this.makeNotionVoid();
        console.error('Failed to fetch subscription status', err);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }
  }
}
